import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Calendar(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Calendar", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.light,
        d: "M6 33.931v5.543A2.526 2.526 0 0 0 8.526 42h30.948A2.526 2.526 0 0 0 42 39.474V33.93H6Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: theme.vars.palette.secondary.main, d: "M36.414 39.517 42 33.931v-18.62H6v24.163l30.414.043Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.secondary.dark,
        d: "M36.414 33.931H42l-5.586 5.586v-5.586Zm1.862-24.828H9.724A3.724 3.724 0 0 0 6 12.828v3.947h36v-3.947a3.724 3.724 0 0 0-3.724-3.725Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.dark,
        d: "M15.994 6a1.608 1.608 0 0 0-1.614 1.614v3.42a1.614 1.614 0 0 0 3.221 0v-3.42A1.608 1.608 0 0 0 15.994 6Zm16.02 0A1.608 1.608 0 0 0 30.4 7.614v3.42a1.614 1.614 0 0 0 3.221 0v-3.42A1.608 1.608 0 0 0 32.014 6Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.light,
        d: "M15.254 19.432H19.2v3.947h-3.947v-3.947Zm6.772 0h3.947v3.947h-3.947v-3.947Zm6.771 0h3.948v3.947h-3.948v-3.947Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: theme.vars.palette.primary.dark, d: "M35.57 19.431h3.948v3.948H35.57v-3.948Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.light,
        d: "M8.483 26.26h3.948v3.947H8.483v-3.948Zm6.772 0h3.948v3.947h-3.948v-3.948Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: theme.vars.palette.primary.dark, d: "M22.025 26.26h3.948v3.947h-3.948v-3.948Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.light,
        d: "M28.799 26.26h3.947v3.947H28.8v-3.948Zm6.771 0h3.948v3.947H35.57v-3.948ZM8.483 33.086h3.948v3.947H8.483v-3.947Zm6.772 0h3.948v3.947h-3.948v-3.947Zm6.772 0h3.947v3.947h-3.947v-3.947Z"
      }
    )
  ] });
}
Calendar.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Calendar"
};
validateTidalLicense();
export {
  Calendar
};
//# sourceMappingURL=Calendar.js.map
